/**
 * Homepage membership chrome hydration.
 *
 * The homepage is public, cached for signed-out visitors, and personalized for
 * cookie-authenticated members. SSR owns first paint; this helper keeps the
 * nav/pricing chrome aligned after client-side login/logout transitions.
 */

export interface LandingMembershipChromeState {
  isAuthenticated: boolean;
  isPaid: boolean;
}

export function updateLandingMembershipChrome(state: LandingMembershipChromeState): void {
  const navCta = document.querySelector('.nav-cta');
  if (isMutableAnchor(navCta)) {
    navCta.textContent = state.isAuthenticated ? 'Settings' : 'Join the club';
    navCta.setAttribute('href', state.isAuthenticated ? '/options' : '/join');
  }

  const pricingSection = document.getElementById('pricing');
  if (pricingSection) {
    pricingSection.hidden = state.isPaid;
  }

  const pricingNavLink = document.querySelector('.nav-link[href="#pricing"]');
  if (isMutableAnchor(pricingNavLink)) {
    pricingNavLink.hidden = state.isPaid;
    pricingNavLink.setAttribute('aria-hidden', state.isPaid ? 'true' : 'false');
    pricingNavLink.tabIndex = state.isPaid ? -1 : 0;
  }
}

function isMutableAnchor(value: Element | null): value is HTMLAnchorElement {
  return Boolean(value && 'setAttribute' in value && 'tabIndex' in value);
}
